import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import Undo from 'material-ui/svg-icons/content/undo'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import TablePagination from '@material-ui/core/TablePagination'
import { probabilitiesActions, confirmActions, messageActions } from '../../actions'
import Typography from '@material-ui/core/Typography'
import { listTableStyle } from '../../styles'
import { reloadTable } from '../../utils/reloadTable'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'

class ListTable extends Component {
  state = {
    debounce: null
  }

  componentWillUpdate(newProps) {
    const { pagination, order, fetchProbabilities, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchProbabilities({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  componentDidMount() {
    const { fetchProbabilities, changeOrderColumn, order, term } = this.props
    fetchProbabilities()
  }

  renderActions = item => {
    const {
      fetchProbability,
      deleteProbability,
      addConfirm,
      token,
      restoreProbability
    } = this.props

    return (
      <Fragment>
        {readOnly('probabilidades', token) &&
          !item.deletedAt && (
            <IconButton
              onClick={() => {
                fetchProbability(item._id)
              }}
            >
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!item.deletedAt && findPermission('probabilidades', token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração desta probabilidade?',
                confirmFunction: () => {
                  restoreProbability(item._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission('probabilidades', token).editar && (
              <IconButton
                onClick={() => {
                  fetchProbability(item._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('probabilidades', token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão desta probabilidade?',
                    confirmFunction: () => {
                      deleteProbability(item._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  handleChangePage = (event, page) => {
    const { handleChangePage } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { handleChangePerPage } = this.props
    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection, pagination } = this.props

    const { page, rowsPerPage: perPage } = pagination

    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  render() {
    const {
      classes,
      probabilities = [],
      loadingProbabilities,
      addConfirm,
      restoreProbability,
      pagination,
      order = {}
    } = this.props
    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingProbabilities && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}
        <Table
          fixedHeader={true}
          width={'990px'}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'nome'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('nome')
                  }}
                >
                  Probabilidade
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false} className={classes.tableBody}>
            {(probabilities || []).length ? (
              (probabilities || []).map(content => {
                return (
                  <TableRow key={content._id}>
                    <TableRowColumn>{content.nome}</TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(content)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingProbabilities ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            rowsPerPageOptions={[25, 50, 100]}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    probability: state.probabilities.probability,
    probabilities: state.probabilities.probabilities,
    loadingProbabilities: state.probabilities.loadingProbabilities,
    token: state.auth.token,
    pagination: state.probabilities.probabilitiesPagination,
    order: state.probabilities.order,
    term: state.searchTable.term
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(probabilitiesActions.openModal())
    },
    closeModal: () => {
      dispatch(probabilitiesActions.closeModal())
    },
    fetchProbability: id => {
      dispatch(probabilitiesActions.fetchProbability(id))
    },
    fetchProbabilities: options => {
      dispatch(probabilitiesActions.fetchProbabilities(options))
    },
    deleteProbability: id => {
      dispatch(probabilitiesActions.deleteProbability(id))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    restoreProbability: id => {
      dispatch(probabilitiesActions.restoreProbability(id))
    },
    handleChangePage: page => {
      dispatch(probabilitiesActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(probabilitiesActions.handleChangePerPage(perPage))
    },
    changeOrderColumn: column => {
      dispatch(probabilitiesActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(probabilitiesActions.changeOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/Probabilities/ListTable.js